import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8998374"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "open__main_container",
  class: "main_container"
}
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "클럽딜 열기", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "top_container"
}
const _hoisted_9 = { class: "info-wrapper" }
const _hoisted_10 = { class: "info_left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_b.png",
  srcset: "/assets/icon/btn_right_b@2x.png 2x,/assets/icon/btn_right_b@3x.png 3x"
}, null, -1))
const _hoisted_12 = { class: "company_detail" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/leaf.png",
  class: "leaf"
}, null, -1))
const _hoisted_14 = { class: "green" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('|'))
const _hoisted_16 = { class: "green" }
const _hoisted_17 = { class: "info_right" }
const _hoisted_18 = { class: "company_info_left" }
const _hoisted_19 = { class: "company_logo" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_22 = { class: "content_wrap" }
const _hoisted_23 = { class: "content_title" }
const _hoisted_24 = { class: "deal_content" }
const _hoisted_25 = { class: "space-between" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 판매 금액 ", -1))
const _hoisted_27 = { class: "deal_right" }
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = { class: "space-between" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 주당 가격 ", -1))
const _hoisted_31 = {
  class: "deal_right",
  style: {display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "bold" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "space-between" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 가격협의 ", -1))
const _hoisted_38 = { class: "deal_right" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "white_container" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_title" }, " 클럽딜 열기 조건 ", -1))
const _hoisted_43 = { class: "deal_content" }
const _hoisted_44 = { class: "space-between" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 리드엔젤 참여 가능 범위 ", -1))
const _hoisted_46 = { class: "deal_right" }
const _hoisted_47 = { class: "bold" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 원 ~ ")
const _hoisted_49 = { class: "bold" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_51 = { class: "space-between" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 1인 참여 가능 범위 ", -1))
const _hoisted_53 = { class: "deal_right" }
const _hoisted_54 = { class: "bold" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 원 ~ ")
const _hoisted_56 = { class: "bold" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_58 = { class: "space-between" }
const _hoisted_59 = { class: "img_align help_circle" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "서비스 이용료", -1))
const _hoisted_61 = { class: "deal_right" }
const _hoisted_62 = { class: "bold" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_64 = {
  key: 0,
  class: "content_wrap"
}
const _hoisted_65 = { class: "value_container" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_18B" }, " 가격 정보 ", -1))
const _hoisted_67 = {
  style: {"margin-top":"10px"},
  class: "value_image"
}
const _hoisted_68 = ["src"]
const _hoisted_69 = ["src", "srcset"]
const _hoisted_70 = {
  key: 1,
  class: "white_container"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_18B" }, " 성장성분석 그래프 ", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gray main_13R",
  style: {"margin-top":"3px"}
}, " 총 인원수, 모바일앱 월 사용자수를 한눈에! ", -1))
const _hoisted_73 = { style: {"margin-top":"10px","margin-bottom":"10px"} }
const _hoisted_74 = ["src"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray center main_13R" }, " 이 회사의 고용, 사용자, 재무정보 등 성장지표가 궁금하다면? ", -1))
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 혁신의숲에서 자세히보기 ")
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leadangel_box" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "leadangel_title" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "leadAngel",
        src: "/assets/icon/leadangel.png",
        srcset: "/assets/icon/leadangel@2x.png 2x,/assets/icon/leadangel@3x.png 3x"
      }),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "클럽딜을 열어주세요!")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "leadangel_info" }, [
      /*#__PURE__*/_createTextVNode(" 이 매물 공동구매 하고 싶으시면,"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 안내에 따라 클럽딜 열기 요청하고"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 클럽딜 열기 혜택 누리세요! ")
    ]),
    /*#__PURE__*/_createElementVNode("ol", { class: "lead_list" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("클럽딜 열기 혜택 : "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "서비스 이용료 0원, 10만포인트 적립")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("화면 하단의 "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "클럽딜 열기 버튼"),
        /*#__PURE__*/_createTextVNode("을 눌러 "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "클럽딜 열기를 요청"),
        /*#__PURE__*/_createTextVNode("할 수 있습니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("판매 조건에 따라, 클럽딜 열기 요청시 "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "판매자와 가격 협의"),
        /*#__PURE__*/_createTextVNode("가 가능할 수 있습니다. 단, 가격 협의 중 다른 리드엔젤이 기존 조건으로 먼저 클럽딜을 열 수 있습니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("클럽딜 열기를 요청하신 후 입금 계좌를 안내해드리며, 본인 출자금을 "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "100만원이상 ~ 1인 참여 가능 최대금액 이하를 입금"),
        /*#__PURE__*/_createTextVNode("해주시면 클럽딜이 열립니다. ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("입금 계좌 안내 후, "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "다음 날 오후 5시까지"),
        /*#__PURE__*/_createTextVNode(" 출자금 입금이 확인 되지 않으면, 클럽딜 열기 요청은 자동 취소됩니다. ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "출자금 선착순 입금순"),
        /*#__PURE__*/_createTextVNode("으로 해당 클럽딜의 리드엔젤이 지정됩니다. 먼저 클럽딜 열기 요청을 하셨어도 입금이 늦어 요청이 취소될 수 있습니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("해당 클럽딜의 리드엔젤이 지정된 후 "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "2일 후 오전 11시 30분"),
        /*#__PURE__*/_createTextVNode("에 클럽딜이 열려, 조합원을 모집할 수 있습니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("리드엔젤은 조합 생성시 업무집행 조합원이 되며, 그에 따른 몇 가지 준비서류가 필요합니다. "),
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "클럽딜이 진행되면 엔젤리그가 상세 안내를 드립니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "리드엔젤이 추천한 3인은 클럽딜 오픈전 우선 참여 가능합니다. (MY탭>설정에서 1:1 문의로 알려주세요)"),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "10명 이상이 참여해야 조합 생성이 진행됩니다.")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "1년이 지나면 조합의 지분을 매도하실 수 있으나, 리드조합원은 지분의 80%까지만 매도하실 수 있고 나머지 조합 해산시까지 보유하셔야 합니다.")
    ])
  ])
], -1))
const _hoisted_78 = { id: "info_box" }
const _hoisted_79 = { class: "info_container" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "info_container" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = { class: "news_list" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_87 = { class: "news_list" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_89 = { class: "news_list" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_91 = { class: "news_list" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_93 = { class: "news_list" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수", -1))
const _hoisted_95 = { class: "info_container" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_97 = { class: "doc_left" }
const _hoisted_98 = { class: "item_left" }
const _hoisted_99 = { class: "series" }
const _hoisted_100 = { class: "info_date gray" }
const _hoisted_101 = { class: "item_center" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_103 = { class: "doc_right" }
const _hoisted_104 = { class: "strong" }
const _hoisted_105 = { class: "info_container" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_107 = { class: "doc_left" }
const _hoisted_108 = { class: "info_date gray" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "doc_right" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "출자 위험 안내")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, [
    /*#__PURE__*/_createTextVNode(" 본 위험고지서는 귀하가 (주)엔젤리그가 운영하는 서비스 위에서, 업무집행조합원과 함께 조합에 참여하여 조합을 공동경영하기 전에 출자의 위험을 사전에 충분히 인지할 수 있도록 (주)엔젤리그가 귀하에게 고지하는 내용입니다."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 1. 귀하의 출자대상은 조합의 지분으로서 투자대상회사의 주식 그 자체가 아닙니다. 설립되는 조합이 비상장주식을 매수하게 되며 귀하는 그 조합의 지분을 보유하게 됩니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 2. 조합의 업무집행조합원 및 다른 조합원은 귀하와 조합의 동업자로서, 조합 출자재산의 운영 및 배분은 조합원 전원의 합의로 이루어지고, 업무집행조합원은 조합의 출자재산을 운용하지 않습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 3. 조합의 매수대상인 투자대상회사의 증권은 원본손실의 위험성이 있으며, 출자한 자금의 원본을 회수할 없음에 따른 손실의 위험이 있음을 이해합니다. 또한 귀하가 예상하거나 기대하는 수익의 일부 또는 전부를 얻지 못할 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 4. 귀하는 (주)엔젤리그의 홈페이지에 게재된 매수대상회사에 대한 설명, 매수대상회사의 매수조건, 매수대상회사의 매수 시점 및 가격, 업무집행조합원의 성과보수, 업무집행조합원의 역할, 출자위험요소 등을 충분히 확인하였습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 5. 귀하는 (주)엔젤리그는 업무집행조합원이 안전하고 쉽게 조합을 만드는 것을 도와주는 역할만 수행하므로 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 조합의 업무집행조합원 역시 귀하와 같이 조합을 설립하고 운영하는 동업자로서 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 즉, 출자에 대한 모든 위험은 본인에게 있음을 확인합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 6. 귀하는 조합을 통해 매수하는 매수대상회사의 비상장증권은 한국거래소의 상장을 목적으로 하는 것이 아니며, 따라서 증권의 환금성에 큰 제약이 있다는 점과 예상 회수금액에 대한 일부 혹은 전부를 회수할 수 없는 위험이 있음을 이해하며, 귀하가 이를 감당할 수 있음을 확인합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 7. 조합이 매수하게 되는 매수대상회사가 비상장 기업인 경우 성장초기단계에 있는 경우가 많기 때문에, 정기 배당을 실시하는 경우가 매우 드뭅니다. 따라서 배당수익을 기대하고 출자를 할 경우 기대한 만큼의 수익을 얻지 못할 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 8. 조합이 매수하게 되는 매수대상회사는 지속적으로 성장하기위하여 해당 기업의 정관에 근거하여 유상증자를 실시할 가능성이 높습니다. 유상증자로 인하여 조합이 보유한 지분율은 감소될 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 9. 귀하는 시장의 상황, 제도의 변경이 있을 수 있으며, 자본시장법 등 관련법규에 근거하여 출자의 한도에 제한이 있는 경우 이를 준수하여야 함을 이해합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 10. 귀하는 귀하가 보유한 조합의 지분에 대하여 원칙적으로 1년간 전매가 제한된다는 점을 이해합니다. 단, 조합이 보유한 매수대상회사의 주식은 아무런 제한 없이 매매가 가능합니다. "),
  /*#__PURE__*/_createElementVNode("b", null, "위 사항들은 조합의 출자에 수반되는 위험과 관련하여 귀하가 알아야 할 사항을 간략하게 서술한 것으로 귀하의 위 거래와 관련하여 발생될 수 있는 모든 위험과 중요 사항을 전부 기술한 것은 아닙니다. 따라서 상세한 내용은 (주)엔젤리그 및 관계법규를 통하여 확인하여야 합니다.")
], -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "related_title medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "환불 정보")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "refund_list" }, [
      /*#__PURE__*/_createElementVNode("li", null, "단순 변심으로 인한 환불 : 환불 수수료 10만원"),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 발송 이후 : 환불 수수료 20만원 "),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 서명 이후 : 환불 불가")
    ]),
    /*#__PURE__*/_createTextVNode(" 비상장주식회사의 비통일주권의 거래를 위해,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 주식양수도계약, 명의개서*를 완료 해야 합니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 본 과정은 리드엔젤과 (주)엔젤리그가 안전하게 진행합니다. 단, 계약이 완료되지 못한 경우, 바로 공지드리며 영업일 기준 D+8내에 입력하신 환불계좌로 전액 환불됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 입금 선착순에 의한 환불인 경우 사용된 포인트는 3영업일 이내에 복원됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "blue sub_text" }, "*명의개서 : 회사에서 주주명부에 새로운 주주로 등재하는 것")
  ])
], -1))
const _hoisted_114 = { class: "white_container" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 함께 본 클럽딜 ", -1))
const _hoisted_116 = { class: "clubdeal-badge" }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { class: "logo" }
const _hoisted_119 = ["src"]
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_121 = { class: "white_container" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "엔젤리그 사용법")
], -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rec_img",
    src: "/assets/image/img@3x.png",
    alt: ""
  })
], -1))
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" 엔젤리그소개 ")
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" 자주묻는질문 ")
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" 조합생성과정 ")
const _hoisted_127 = {
  key: 0,
  class: "footer_container space-between"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray_btn footer_btn" }, " MY매물. 클럽딜이 열리기를 기다려 주세요 ", -1))
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" 참여금 입금 확인중. 입금정보 보기 ")
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_w.png",
  alt: "",
  class: "btn_open",
  srcset: "/assets/icon/btn_right_w@2x.png 2x,/assets/icon/btn_right_w@3x.png 3x"
}, null, -1))
const _hoisted_132 = { class: "ion-activatable ripple-parent gray_btn footer_btn" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" 클럽딜 열기 취소하기 ")
const _hoisted_134 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray_btn footer_btn" }, " 리드엔젤 참여금 입금 완료 ", -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = {
  key: 0,
  class: "footer_container space-between"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray_btn footer_btn" }, " 리드엔젤 참여금 입금 완료 ", -1))
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" 다른 클럽딜 참여금 입금 확인중 ")
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_open.png",
  alt: "",
  class: "btn_open",
  srcset: "/assets/icon/btn_open@2x.png 2x,/assets/icon/btn_open@3x.png 3x"
}, null, -1))
const _hoisted_143 = {
  key: 0,
  class: "footer_container space-between"
}
const _hoisted_144 = /*#__PURE__*/_createTextVNode(" 판매자와 가격협의중 > ")
const _hoisted_145 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" 가격협의 후 열기 ")
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 이 조건으로 열기 ")
const _hoisted_148 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_149 = /*#__PURE__*/_createTextVNode(" 이 조건으로 열기 ")
const _hoisted_150 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_151 = /*#__PURE__*/_createTextVNode(" 클럽딜 열려면 로그인 > ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "open__ion_content",
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, {
                "pulling-icon": _ctx.arrowDownOutline,
                "refreshing-spinner": "crescent"
              }, null, 8, ["pulling-icon"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'뒤로가기'});_ctx.closeModal();})
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _hoisted_6
                ]),
                _createVNode(_component_ag_box_s, {
                  css: {marginRight: 20},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'공유버튼'});_ctx.onShare()})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_icon, {
                      css: {color: 'gray6', width: 26, height: 26},
                      name: "arrowRedo"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_7,
            (!_ctx.fromCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "company_title",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단회사정보', 'clickContent':`회사상세링크`});_ctx.useCompanyModal(_ctx.partnershipInfo.stockItemId)})
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.stockItemName), 1),
                        _hoisted_11
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_ag_icon, {
                          name: "businessOutline",
                          css: {width: 12, height: 12, mr: 4}
                        }),
                        _createElementVNode("span", null, "추정 시총 " + _toDisplayString(Number(_ctx.currentValuation)?_ctx.numberToKorean(_ctx.currentValuation)+'원':'정보 없음'), 1),
                        _createVNode(_component_ag_icon, {
                          name: "helpCircleOutline",
                          css: {width: 20, height: 20, color: 'gray3'},
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'추정시가총액툴팁'}); _ctx.openPopover2()}, ["stop"]))
                        })
                      ]),
                      _createElementVNode("div", {
                        class: "company_detail",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.useCompanyModal(_ctx.partnershipInfo.stockItemId, undefined, 'board')))
                      }, [
                        _hoisted_13,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardTotalInfo, (b) => {
                          return (_openBlock(), _createElementBlock("span", { key: b }, [
                            _createVNode(_component_ag_box_s, { css: {display: 'flex', direction: 'row'} }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(b.avg_point.substring(0,3)), 1),
                                _createVNode(_component_ag_box_s, { css: {color: 'bg2', mx: 4} }, {
                                  default: _withCtx(() => [
                                    _hoisted_15
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ag_icon, {
                                  name: "chatbubble",
                                  css: {color: 'green1', width: 16, height: 16, mr: 4}
                                }),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(b.count), 1),
                                _createVNode(_component_ag_icon, {
                                  name: "chevronForward",
                                  css: {width: 16, height: 16, color: 'green1'}
                                })
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: _ctx.partnershipInfo.companyLogo ? _ctx.partnershipInfo.companyLogo : '/assets/icon/company_default_img.png',
                          onerror: "this.src='/assets/icon/company_default_img.png'",
                          class: "img-responsive img-circle"
                        }, null, 8, _hoisted_20),
                        _hoisted_21
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.only3(_ctx.partnershipInfo.sellerNickName)) + "님의 판매 조건 ", 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalQty * _ctx.partnershipInfo.price)), 1),
                    _createTextVNode(" 원 (" + _toDisplayString(_ctx.hasSession() ? _ctx.$filters.currency(_ctx.partnershipInfo.totalQty) : '?') + "주) ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.hasSession())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.price)), 1),
                          _hoisted_34
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_35, " 로그인 후 확인 ")),
                    _createVNode(_component_ag_box_s, { css: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, {
                          css: {dp: 'flex', alignItems: 'center', color: _ctx.partnershipInfo.fontColor, typography: 'main12r', bg: 'bg2', borderRadius: '4px', padding:'4px 8px'}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_icon, { name: "businessOutline" }),
                            _createVNode(_component_ag_text_s, { css: {ml:'5px', whiteSpace: 'nowrap'} }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 시총 " + _toDisplayString(_ctx.aaaaa) + "원 상당 ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["css"]),
                        _createVNode(_component_ag_icon, {
                          css: {fontSize: '20px', color: 'gray3', ml:'5px'},
                          name: "helpCircleOutline",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'판매조건', 'clickContent':`시총 툴팁`});_ctx.openPopover(_ctx.aaaaa)})
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.partnershipInfo.sellPriceNegoFlag)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "가능"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40, "불가능"))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.leadAvailableAssetFrom), 1),
                    _hoisted_48,
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.leadAvailableAssetTo), 1),
                    _hoisted_50
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.availableAssetFrom), 1),
                    _hoisted_55,
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.availableAssetTo), 1),
                    _hoisted_57
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("img", {
                      class: "help_circle_img",
                      src: "/assets/icon/help_circle@3x.png",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'클럽딜 열기 조건', 'clickContent':`서비스이용료 툴팁`});_ctx.openPopoverFee()})
                    })
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.leadServiceFee ?? _ctx.partnershipInfo.defaultServiceFee)), 1),
                    _hoisted_63
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.partnershipInfo.investmentMemoChartImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, [
                    (_ctx.isLogin)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.partnershipInfo.investmentMemoChartImg
                        }, null, 8, _hoisted_68))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.frame783Png,
                          srcset: `${_ctx.frame783x2Png} x2, ${_ctx.frame783x3Png} x3`
                        }, null, 8, _hoisted_69))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.partnershipInfo.ifGraphLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _hoisted_71,
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("img", {
                    class: "if-graph",
                    src: _ctx.partnershipInfo.ifGraphLink
                  }, null, 8, _hoisted_74)
                ]),
                _hoisted_75,
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent g_btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'성장성분석 그래프', 'clickContent':'혁신의숲에서 자세히보기'});_ctx.openLink(_ctx.partnershipInfo.ifLink);})
                }, [
                  _hoisted_76,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.press, (info, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "news_list"
                }, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent",
                    onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'뉴스', 'clickContent':'기사 제목'});_ctx.openLink(info.link);}
                  }, [
                    _createTextVNode(_toDisplayString(info.title) + " ", 1),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_81)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("div", {
              class: "company_info",
              innerHTML: _ctx.partnershipInfo.companyIntroduction
            }, null, 8, _hoisted_84),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.stockItemName), 1)
            ]),
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.ceo), 1)
            ]),
            _createElementVNode("div", _hoisted_89, [
              _hoisted_90,
              _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.bizno), 1)
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.transDate(_ctx.partnershipInfo.foundDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalStockAmount)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.investHistory, (v, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "news_list space-between"
              }, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, " Series " + _toDisplayString(v.series), 1),
                    _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$filters.transDate(v.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.investor.split('|'), (investor, idx) => {
                      return (_openBlock(), _createElementBlock("span", { key: idx }, [
                        _createTextVNode(_toDisplayString(investor), 1),
                        _hoisted_102
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("span", _hoisted_104, _toDisplayString(v.value), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.publicAnnouncement, (v, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "news_list space-between"
              }, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$filters.transDate(v.date)), 1),
                  _createElementVNode("span", {
                    class: "ion-activatable ripple-parent info_link",
                    onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'공시자료', 'clickContent':'공시자료 제목'});_ctx.openLink(v.link)}
                  }, [
                    _createTextVNode(_toDisplayString(v.title) + " ", 1),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_109)
                ]),
                _createElementVNode("div", _hoisted_110, _toDisplayString(v.sender), 1)
              ]))
            }), 128))
          ]),
          _hoisted_111,
          _hoisted_112,
          _hoisted_113,
          _createElementVNode("div", _hoisted_114, [
            _hoisted_115,
            _createElementVNode("div", _hoisted_116, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendPartnership, (v, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.partnershipId,
                  class: "badge-container"
                }, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent deal-badge",
                    style: _normalizeStyle({'background' : `${_ctx.recommendPartnership[idx].bgColor}`}),
                    onClick: () =>{
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'함께 본 클럽딜 하단', 'clickContent':`${v.partnershipName}`})
                _ctx.useClubDealProgressModal(v.partnershipId)
              }
                  }, [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("img", {
                        src: _ctx.recommendPartnership[idx].companyLogo ? _ctx.recommendPartnership[idx].companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_119),
                      _hoisted_120
                    ]),
                    _createElementVNode("div", {
                      class: "collecting",
                      style: _normalizeStyle({'color' : `${_ctx.recommendPartnership[idx].fontColor}`})
                    }, _toDisplayString(_ctx.recommendPartnership[idx].partnershipName), 5),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 12, _hoisted_117)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_121, [
            _hoisted_122,
            _hoisted_123,
            _createElementVNode("div", {
              class: "space-between",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openFAQModal($event.target.id)))
            }, [
              _createElementVNode("div", {
                id: "info",
                class: "ion-activatable ripple-parent info_btn",
                style: {"background":"#222"},
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'엔젤리그소개'});})
              }, [
                _hoisted_124,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("div", {
                id: "FAQ",
                class: "ion-activatable ripple-parent info_btn",
                style: {"background":"#4360EC"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'자주묻는질문'});})
              }, [
                _hoisted_125,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("div", {
                id: "process",
                class: "ion-activatable ripple-parent info_btn",
                style: {"background":"#00B7B9"},
                onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'조합생성과정'});})
              }, [
                _hoisted_126,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ])
          ])
        ]),
        _: 1
      }),
      (_ctx.partnershipInfo.partnershipStatus)
        ? (_openBlock(), _createBlock(_component_ion_footer, {
            key: 0,
            class: "ion-no-border",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              (_ctx.hasSession())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.partnershipInfo.isMySellItem)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, _hoisted_129))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.partnershipInfo.joinPartnershipRequest)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.partnershipInfo.joinPartnershipRequest.payConfirm==='notyet')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", {
                                        class: "ion-activatable ripple-parent red_btn footer_btn_narrow",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'참여금 입금 확인중. 입금정보 보기'});_ctx.showBank(_ctx.partnershipRequest)})
                                      }, [
                                        _hoisted_130,
                                        _hoisted_131,
                                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                      ]),
                                      _createElementVNode("div", {
                                        class: "footer_container space-between",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'클럽딜 열기 취소하기'});_ctx.cancelRequest()})
                                      }, [
                                        _createElementVNode("div", _hoisted_132, [
                                          _hoisted_133,
                                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                        ])
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.partnershipInfo.joinPartnershipRequest.payConfirm==='paid')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, _hoisted_136))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.partnershipInfo.partnershipStatus!=='prepare')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, _hoisted_139))
                                  : (_ctx.partnershipInfo.anotherNotYet)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                        _createElementVNode("div", {
                                          class: "ion-activatable ripple-parent red_btn footer_btn",
                                          onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'다른 클럽딜 참여금 입금 확인중'});_ctx.showNotYet()})
                                        }, [
                                          _hoisted_141,
                                          _hoisted_142,
                                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (_ctx.partnershipInfo.sellPriceNegoFlag)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_ctx.partnershipInfo.partnershipOpenChannelId
                    && _ctx.partnershipInfo.partnershipOpenChannelstatus !== 'init'
                    && _ctx.partnershipInfo.partnershipOpenChannelstatus !== 'cancelToSeller'
                    && _ctx.partnershipInfo.partnershipOpenChannelstatus !== 'cancelToLeadAngel'
                    && _ctx.partnershipInfo.partnershipOpenChannelstatus !== 'depositDelayCancel')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                                    _createElementVNode("div", {
                                                      class: "ion-activatable ripple-parent blue_btn footer_btn",
                                                      onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'판매자와 가격협의중'});_ctx.priceNegoFunc()})
                                                    }, [
                                                      _hoisted_144,
                                                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                                    _createElementVNode("div", {
                                                      class: "ion-activatable ripple-parent blue_btn footer_btn",
                                                      onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'가격협의 후 열기'});_ctx.priceNegoFunc()})
                                                    }, [
                                                      _hoisted_146,
                                                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                                    ]),
                                                    _createElementVNode("div", {
                                                      class: "ion-activatable ripple-parent sky_btn footer_btn",
                                                      onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'이 조건으로 열기'});_ctx.openAlert()})
                                                    }, [
                                                      _hoisted_147,
                                                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                                    ])
                                                  ]))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                              _createElementVNode("div", {
                                                class: "ion-activatable ripple-parent sky_btn footer_btn",
                                                onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'이 조건으로 열기'});_ctx.openAlert()})
                                              }, [
                                                _hoisted_149,
                                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                              ])
                                            ]))
                                      ], 64))
                              ], 64))
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent red_btn footer_btn",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$global.openLoginModal(_ctx.refresh)))
                    }, [
                      _hoisted_151,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}